import "./Footer.css";

export function Footer() {
    return <footer className="footer">Todos os direitos reservados.</footer>;
}
